import { useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  notification,
  Popover,
  Row,
  Space,
  Spin,
  Table,
  Typography,
  Upload,
} from "antd";
import { Helmet } from "react-helmet";
import { InboxOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { http } from "../../../engine/api/http";
import {
  billDueDate,
  daysJsFormat as datesFormats,
  daysJsFormat,
  formatCurrency,
} from "../../../utils/constants";
import dayjs from "../../../utils/dayjs";
import dayjsLib from "dayjs";
import routes from "../../../engine/routes";
const { Dragger } = Upload;
var xmlConverter = require("xml-js");

import "./importer.css";
import CustomTable from "../../../shared/components/CustomTable";
import {
  confirmBillsCamt,
  modalsByContext,
} from "../../../shared/components/Modals/modals";
import { FcCancel } from "react-icons/fc";
import { ModalContext } from "../../../engine/context/Modal.provider";

export function BillingCamt({}) {
  const context = useContext(ModalContext);
  const [validator, setValidator] = useState(null);
  const [camts, setCamts] = useState([]);
  const [selectedRowKeys, onSelectChange] = useState([]);
  const [camtJson, setCamtJson] = useState(null);
  const [data, setData] = useState(null);
  const [fileCount, setFileCount] = useState(0); // To track how many files are being uploaded
  const [processedFiles, setProcessedFiles] = useState(0); // To track how many files are processed
  const [fileList, setFileList] = useState([]); // Add a state to store the file list

  const { t } = useTranslation();

  const sendJsonData = async jsons => {
    try {
      const { data } = await http.post("/bills/banking_validator", { jsons });
      if (data) {
        notification.destroy("uploadXml");

        notification.success({
          message: t("BillingList.camtProcessed"), // Camt traité
        });

        onSelectChange(data.matched.map(i => i._id));

        setValidator(data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const confirmBills = async () => {
    // Take by selectedId

    await confirmBillsCamt({
      onOk: async () => {
        try {
          let paiements = [];

          selectedRowKeys.forEach(i => {
            paiements.push(validator.matched.find(j => j._id === i));
          });

          const call = await http.post("/bills/confirm_bills_camt", {
            paiements,
          });

          notification.success({
            message: t("BillingList.billsConfirmed"), // Factures confirmées
          });

          let prevMatched = validator.matched.filter(i =>
            selectedRowKeys.includes(i._id),
          );

          setValidator(prev => {
            return {
              ...prev,
              matched: prev.matched.filter(
                i => !selectedRowKeys.includes(i._id),
              ),
              matchedPaid: [...prev.matchedPaid, ...call.data],
            };
          });
        } catch (e) {
          console.log(e);
        }
      },
    });

    try {
    } catch (e) {
      console.log(e);
    }
  };

  // Effect to trigger upload and reset state when all files are processed
  useEffect(() => {
    if (fileCount > 0 && fileCount === processedFiles) {
      sendJsonData(camts); // Assuming this function uploads the data

      // Reset the states after upload
      setFileCount(0);
      setProcessedFiles(0);
    }
  }, [fileCount, processedFiles, camts]); // Dependencies on states

  useEffect(() => {
    return () => {};
  }, []);

  const propsDrag = {
    name: "file",
    multiple: true,
    action: "#",
    accept: "text/xml",
    fileList: fileList, // Bind the fileList state to Upload component
    // defaultFileList: fileList, // Bind the fileList state to Upload component
    // showUploadList: true,
    beforeUpload: file => {
      const reader = new FileReader();

      try {
        reader.onload = e => {
          const xml = e.target.result;
          var result1 = xmlConverter.xml2json(xml, {
            compact: true,
            spaces: 4,
          });

          const json = JSON.parse(result1);

          setCamts(prevCamts => [...prevCamts, json]);
          // Increment processed file count
          setProcessedFiles(prevCount => prevCount + 1);

          // uploadImportBanking(json);
        };
        reader.readAsText(file);
      } catch (e) {
        console.log(e);
      }

      // Prevent upload
      return false;
    },
    onChange(info) {
      // Reset file states when new files are selected
      setCamts([]); // Clear previous uploads
      setFileCount(info.fileList.length); // Update the file count
      setProcessedFiles(0); // Reset processed files

      // Update fileList state to maintain control over the file list
      setFileList(info.fileList);

      // Optionally reset fileList after all files are processed
      if (info.file.status === "done" || fileCount === processedFiles) {
        setFileList([]); // Clear fileList once processing is done
      }
    },
  };

  // const propsDrag = {
  //   name: "file",
  //   multiple: true,
  //   action: "#",
  //   accept: "text/xml",
  //   beforeUpload: file => {
  //     const reader = new FileReader();
  //
  //     try {
  //       reader.onload = e => {
  //         const xml = e.target.result;
  //         var result1 = xmlConverter.xml2json(xml, {
  //           compact: true,
  //           spaces: 4,
  //         });
  //
  //         const data = JSON.parse(result1);
  //
  //         try {
  //           const { xmlns } = data.Document._attributes;
  //           if (
  //             xmlns.search("camt.053") !== -1 ||
  //             xmlns.search("camt.054") !== -1
  //           ) {
  //             notification.open({
  //               key: "uploadXml",
  //               message: t("BillingList.processingFile"),
  //               description: <Spin />,
  //               duration: 4000,
  //             });
  //             sendJsonData(data);
  //           } else {
  //             notification.error({
  //               message: t("BillingList.notCamtFile"),
  //             });
  //           }
  //         } catch (e) {
  //           notification.error({
  //             message: t("BillingList.notISOFile"),
  //           });
  //         }
  //       };
  //       reader.readAsText(file);
  //     } catch (e) {
  //       console.log(e);
  //     }
  //
  //     // Prevent upload
  //     return false;
  //   },
  //   onDrop(e) {},
  // };

  const columns = [
    {
      title: "Payé par",
      dataIndex: "debitor",
      key: "debitor",
    },
    {
      title: "Payé par compte",
      dataIndex: "debitorAccount",
      key: "debitorAccount",
    },
    {
      title: "Référence",
      width: "20%",
      dataIndex: "ref",
      key: "ref",
    },
    {
      title: "Montant",
      width: "10%",
      dataIndex: "amount",
      key: "amount",
      render: (i, item) => formatCurrency(i),
      sorter: (a, b) => a.amount - b.amount,
    },
    {
      title: "Payé le",
      dataIndex: "paidDate",
      key: "paidDate",
      width: "10%",
      render: paidDate => (
        <span>{dayjs(paidDate).format(daysJsFormat.day)}</span>
      ),
      sorter: (a, b) => new Date(a.paidDate) - new Date(b.paidDate),
    },
  ];

  const linkBill = (item, key) => {
    context.openModal(modalsByContext.BillCamtLinking, { item, key }, p => {
      if (p.bill !== undefined) {
        setValidator(prev => {
          let newByKey = prev[p.key].filter(i => i.bankId !== item.bankId);

          item.bill = p.bill;
          item.billId = p.billId;
          prev.matchedPaid.push(item);

          return { ...prev, [p.key]: [...newByKey] };
        });
      }
    });
  };

  const collBills = (key, invoiceSuggest = false) => [
    {
      title: t("camt.paidBy"), // Payé par
      dataIndex: "debitor",
      key: "debitor",
    },
    {
      title: "BankId", // Payé par
      dataIndex: "bankId",
      key: "bankId",
    },
    // {
    //   title: t("camt.paidByAccount"), // Payé par compte
    //   dataIndex: "debitorAccount",
    //   key: "debitorAccount",
    //   width: "200px",
    // },
    {
      title: t("camt.reference"), // Référence
      width: "300px",
      dataIndex: "ref",
      key: "ref",
      render: (i, item) => {
        let flag = false;

        if (
          typeof item?.bill?.reference === "string" &&
          item.ref.toString() !==
            item?.bill?.reference.toString().replace(/\s+/g, "")
        ) {
          flag = true;
        }

        return flag ? (
          <div>
            <span>
              <strike>{item.ref}</strike>
              <br />
              <span style={{ color: "green" }}>
                {item?.bill?.reference.toString().replace(/\s+/g, "")}
              </span>
            </span>
          </div>
        ) : (
          item.ref
        );
      },
      sorter: (a, b) => a.ref.localeCompare(b.ref),
    },
    {
      title: t("camt.paidOn"), // Payé le
      dataIndex: "paidDate",
      key: "paidDate",
      width: "10%",
      render: paidDate => (
        <span>{dayjs(paidDate).format(daysJsFormat.day)}</span>
      ),
      sorter: (a, b) => new Date(a.paidDate) - new Date(b.paidDate),
    },
    {
      title: t("camt.dueDate"), // Date dû
      dataIndex: "bill.due",
      key: "bill.due",
      render: (i, item) => {
        let flag = false;
        if (
          dayjsLib(billDueDate(item.bill), "DD.MM.YYYY").isBefore(
            dayjs(item.paidDate),
          )
        ) {
          flag = true;
        }

        let style = {};

        return (
          <div className={flag && "badgeflag"}>
            <span className={flag && "flag"} style={style}>
              {billDueDate(item?.bill)}
            </span>
          </div>
        );
      },
    },
    {
      title: t("camt.receivedAmount"), // Montant reçu
      width: "10%",
      dataIndex: "amount",
      key: "amount",
      render: (i, item) => {
        let flag = Number(item?.amount) !== Number(item?.amountBill);

        return item?.amount ? (
          <div className={flag && "badgeflag"}>
            <span className={flag && "flag"}>{formatCurrency(i)}</span>
          </div>
        ) : (
          "-"
        );
      },
      sorter: (a, b) => a.amount - b.amount,
    },
    {
      title: t("camt.amountToPay"), // Montant à payé
      width: "10%",
      dataIndex: "amountBill",
      key: "amountBill",
      render: (i, item) => (i ? formatCurrency(i) : "-"),
      sorter: (a, b) => a.amountBill - b.amountBill,
    },
    {
      title: t("camt.institution"), // Institution
      width: "10%",
      dataIndex: "institu",
      key: "institu",
      render: (i, item) => item?.bill?.institution?.name,
      sorter: (a, b) =>
        a?.bill?.institution?.name?.localeCompare(b?.bill?.institution?.name),
    },
    {
      title: t("camt.invoice"), // Facture
      dataIndex: "bill.label",
      key: "bill.label",
      render: (i, item) => {
        if (item?.bill?._id && item?.bill?.camt?.bankId === item.bankId) {
          return (
            <a
              target={"_blank"}
              href={routes.billing(item?.bill?._id).detail.path}
            >
              {item.bill.bill_number}
            </a>
          );
        } else {
          return (
            <a target={"_blank"} onClick={() => linkBill(item, key)}>
              {t("camt.linkToInvoice")} {/* Associer à une facture */}
            </a>
          );
        }
      },
    },
    {
      title: t("camt.invoiceSuggest"), // Facture
      dataIndex: "bill.label2",
      key: "bill.label2",
      visible: invoiceSuggest,
      render: (i, item) => {
        return item?.bill?._id ? (
          <a
            target={"_blank"}
            href={routes.billing(item?.bill?._id).detail.path}
          >
            {item?.bill?.camt?.bankId !== item.bankId && item.bill.bill_number}

            {item?.bill?.camt?.bankId !== undefined &&
              item?.bill?.camt?.bankId !== item.bankId &&
              `* (${t("camt.invoiceInfo")})`}
          </a>
        ) : null;
      },
    },
  ];
  // render function
  return (
    <div className="main-side-content">
      <Helmet>
        <title>{t("BillingList.pageTitle")}</title>
        <meta name="description" content={t("BillingList.pageDescription")} />
      </Helmet>
      <Space
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={2} className={""}>
          {t("BillingList.title")}
        </Typography.Title>

        <div id={"actionsBills"}></div>
      </Space>
      <br />
      <br />
      <div className="">
        <Dragger {...propsDrag}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            {t("BillingList.uploadInstruction")}
          </p>
          <p className="ant-upload-hint">{t("BillingList.uploadHint")}</p>
        </Dragger>
      </div>

      {validator !== null ? (
        <>
          <div style={{ padding: "10 20 10 20", marginTop: 20 }}>
            <h2>{t("camt.titleCreditor")}</h2>
            {validator.creditors.map(c => {
              return (
                <div>
                  <h3>
                    IBAN: <b> {c?.iban}</b>
                  </h3>
                  <h3>
                    {t("camt.nom")}: <b>{c?.name}</b>
                  </h3>
                  {c?.address !== null && (
                    <h3>
                      Address: <b>{c?.address}</b>
                    </h3>
                  )}
                </div>
              );
            })}
          </div>
          <br />
          <Card
            className={"body0Padding"}
            extra={
              validator.matched.length > 0 && (
                <Button
                  type={"primary"}
                  style={{ margin: 20 }}
                  onClick={confirmBills}
                  disabled={selectedRowKeys.length === 0}
                >
                  {t("camt.confirmSelectedPayments")}{" "}
                  {/* Confirmer les paiements sélectionnés */}
                </Button>
              )
            }
            title={
              <>
                {t("camt.paymentsToValidate", {
                  count: validator.matched.length,
                })}{" "}
                {/* Paiements à valider */}
                <Popover
                  overlayStyle={{
                    width: "20vw",
                  }}
                  content={
                    <Space direction={"vertical"}>
                      <span>
                        {t("camt.validationSection")}{" "}
                        {/* Cette section permet une vérification complète avant la confirmation des paiements. */}
                        <br />
                        {t("camt.completeMatch")}{" "}
                        {/* Les paiements correspondant totalement (montant et date) à des factures du système, présentés pour une validation finale avant d'être marqués comme payés. */}
                        <br />
                        {t("camt.dateDiff")}{" "}
                        {/* Les paiements dont la date diffère potentiellement de la date prévue. */}
                        {t("camt.highlightLatePayments")}{" "}
                        {/* Les dates de paiement dépassées seront mises en surbrillance pour faciliter l'identification des paiements tardifs. */}
                      </span>
                    </Space>
                  }
                  title={"Information"}
                >
                  <InfoCircleOutlined />{" "}
                </Popover>
              </>
            }
          >
            {validator.matched.length > 0 && (
              <CustomTable
                hasSelection={true}
                rowSelectedKeys={selectedRowKeys}
                onSelectChange={onSelectChange}
                pagination
                rowKey="_id"
                dataSource={validator.matched}
                columns={[...collBills("matched", true)]}
              />
            )}
          </Card>
          <br />
          <Card
            className={"body0Padding"}
            title={
              <>
                {t("camt.paymentDiscrepanciesTitle", {
                  count: validator.matchedNotAmount.length,
                })}{" "}
                {/* Écarts de paiement */}
                <Popover
                  overlayStyle={{
                    width: "20vw",
                  }}
                  content={
                    <Space direction={"vertical"}>
                      <span>
                        {t("camt.paymentDiscrepancies")}{" "}
                        {/* La section "Écarts de paiement" isole les factures pour lesquelles il existe une différence entre le montant facturé et le montant effectivement payé. */}
                      </span>
                    </Space>
                  }
                  title={"Information"}
                >
                  <InfoCircleOutlined />{" "}
                </Popover>
              </>
            }
          >
            {validator.matchedNotAmount.length > 0 && (
              <CustomTable
                hasPagination={true}
                pagination
                rowKey="_id"
                dataSource={validator.matchedNotAmount}
                columns={[...collBills("matchedNotAmount")]}
              />
            )}
          </Card>

          <br />
          <Card
            className={"body0Padding"}
            title={
              <>
                {t("camt.duplicatePaymentsTitle", {
                  count: validator.duplicated.length,
                })}{" "}
                {/* Doublons de paiement */}
                <Popover
                  overlayStyle={{
                    width: "20vw",
                  }}
                  content={
                    <Space direction={"vertical"}>
                      <span>
                        {t("camt.duplicatePayments")}{" "}
                        {/* La section "Doublons de paiement" met en évidence les transactions qui semblent être des duplicatas. */}
                        <br />
                        {t("camt.duplicateCategories")}{" "}
                        {/* Les doublons de paiement peuvent être classés dans deux catégories principales : les paiements multiples pour une même facture et l'utilisation du même numéro de référence pour différentes transactions. */}
                        <br />
                        {t("camt.associateBillAction")}{" "}
                        {/* L'action "Associer à une facture" permet de lier un paiement problématique à la facture correspondante dans notre système, résolvant ainsi divers types de conflits et d'erreurs de référencement. */}
                      </span>
                    </Space>
                  }
                  title={"Information"}
                >
                  <InfoCircleOutlined />{" "}
                </Popover>
              </>
            }
          >
            {validator.duplicated.length > 0 && (
              <CustomTable
                hasPagination={true}
                pagination
                rowKey="_id"
                dataSource={validator.duplicated}
                columns={[...collBills("duplicated", true)]}
              />
            )}
          </Card>
          <br />
          <Card
            className={"body0Padding"}
            title={
              <>
                {t("camt.unidentifiedPaymentsTitle", {
                  count: validator.notMatched.length,
                })}{" "}
                {/* Paiements non identifiés */}
                <Popover
                  overlayStyle={{
                    width: "20vw",
                  }}
                  content={
                    <Space direction={"vertical"}>
                      <span>
                        {t("camt.unidentifiedPayments")}{" "}
                        {/* La section "Paiements non identifiés" met en évidence les transactions qui ne peuvent pas être associées automatiquement à une facture dans notre système. */}
                        <br />
                        {t("camt.unidentifiedReasons")}{" "}
                        {/* Ces paiements ne contiennent pas de numéro de référence correspondant à une facture existante. */}
                        {t("camt.associateBillExplanation")}{" "}
                        {/* L'action "Associer à une facture" permet de lier un paiement non identifié à la facture correspondante dans notre système, résolvant ainsi divers types de conflits et d'erreurs de référencement. */}
                      </span>
                    </Space>
                  }
                  title={"Information"}
                >
                  <InfoCircleOutlined />{" "}
                </Popover>
              </>
            }
          >
            {validator.notMatched.length > 0 && (
              <CustomTable
                hasPagination={true}
                pagination
                rowKey="_id"
                dataSource={validator.notMatched}
                columns={[...collBills("notMatched")]}
              />
            )}
          </Card>
          <br />
          <Card
            className={"body0Padding"}
            key={validator.matchedPaid.length}
            title={
              <>
                {t("camt.alreadyProcessedPaymentsTitle", {
                  count: validator.matchedPaid.length,
                })}{" "}
                {/* Paiements déjà traités */}
                <Popover
                  overlayStyle={{
                    width: "20vw",
                  }}
                  content={
                    <Space direction={"vertical"}>
                      <span>
                        {t("camt.alreadyProcessedPayments")}{" "}
                        {/* Cette section affiche les transactions qui correspondent à des factures déjà marquées comme payées dans notre système. */}
                        <br />
                        {t("camt.noActionNeeded")}{" "}
                        {/* Ces paiements ont été traités précédemment et ne nécessitent pas d'action supplémentaire. */}
                      </span>
                    </Space>
                  }
                  title={"Information"}
                >
                  <InfoCircleOutlined />{" "}
                </Popover>
              </>
            }
          >
            {validator.matchedPaid.length > 0 && (
              <CustomTable
                hasPagination={true}
                pagination
                rowKey="_id"
                dataSource={validator.matchedPaid}
                columns={[...collBills("matchedPaid")]}
              />
            )}
          </Card>
        </>
      ) : null}
    </div>
  );
}
